// Map a doctor's specialty slug (or first-of-many) to a sharp anatomical
// banner WebP rendered by Gemini Nano Banana and saved under
// /public/specialty-banners/. Used on the patient-side "My Trusted Medical
// Clinics" page (and previews) to make each doctor card instantly
// recognisable at a glance.

// Aliases — the DB has both new + legacy slugs for the same specialty.
// Keep this list in sync with `SPECIALTY_PALETTE` in /backend/routes/branding.py.
const ALIASES = {
  general_medicine: 'physician',
  internal_medicine: 'physician',
  general_physician: 'physician',
  family_medicine: 'physician',
  general_surgery: 'physician',
  ophthalmology: 'physician',
  ent_surgery: 'ent',
  otolaryngology: 'ent',
  audiology: 'ent',
  cosmetology: 'dermatology',
  aesthetic_medicine: 'dermatology',
  paediatrics: 'pediatrics',
  gynaecology: 'gynecology',
  obs_gyn: 'gynecology',
  obstetrics: 'gynecology',
  orthopaedics: 'orthopedics',
  ortho: 'orthopedics',
  cardiologist: 'cardiology',
  dermatologist: 'dermatology',
};

const AVAILABLE = new Set([
  'cardiology', 'dermatology', 'ent', 'gastroenterology', 'physician',
  'general_medicine', 'internal_medicine', 'gynecology', 'neurology',
  'neurosurgery', 'oncology', 'orthopedics', 'pediatrics', 'psychiatry',
  'pulmonology', 'urology', 'dentistry', 'endocrinology', 'nephrology',
  'rheumatology', 'plastic_surgery', 'allergy_immunology', 'radiology',
  'anesthesiology', 'physiotherapy', 'diabetology', 'infectious_disease',
  'vascular_surgery', 'pain_management',
]);

const normalise = (slug) => {
  if (!slug) return null;
  const s = String(slug).trim().toLowerCase().replace(/[\s-]+/g, '_');
  return ALIASES[s] || s;
};

// Pick the most specific banner for a doctor based on their primary
// specialisation. Returns the public URL (or `null` if no banner matches
// — caller can render a neutral fallback gradient + Stethoscope icon).
export function bannerForDoctor(specializations) {
  const list = Array.isArray(specializations) ? specializations : [];
  for (const raw of list) {
    const slug = normalise(raw);
    if (slug && AVAILABLE.has(slug)) return `/specialty-banners/${slug}.webp`;
  }
  // Fallback: generic "physician" banner if we have nothing.
  return AVAILABLE.has('physician') ? '/specialty-banners/physician.webp' : null;
}

export default bannerForDoctor;
